import permisosFinancieroPG, { RESOURCE_FINANCIERO_PG } from '@/auth/permissions/modules/financiero'
import { defineMenu } from '@/utils/menu'
import * as names from '@routes/financiero-pg/nombres/informes'

const { informes } = permisosFinancieroPG
export default defineMenu([
    {
        title: 'financiero-pg.subopciones.reporte_status',
        action: informes.reporteStatus,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_REPORTE_STATUS,
    },
    {
        title: 'financiero-pg.subopciones.archivo_bancos',
        action: informes.archivoBancos,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_ARCHIVO_BANCOS,
    },
    {
        title: 'financiero-pg.subopciones.libro_bancos',
        action: informes.libroBancos,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_LIBRO_BANCOS,
    },
    {
        title: 'financiero-pg.subopciones.movimientos_bancarios',
        action: informes.movimientosBancarios,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_MOVIMIENTOS_BANCARIOS,
    },
    {
        title: 'financiero-pg.subopciones.reporte_pagos',
        action: informes.reportePagos,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_REPORTE_PAGOS,
    },
])
